export default __webpack_public_path__ + "static/media/table-waiting.50129f08.svg";